import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { ReportStatus } from '@e-origin/shared';

const c = initContract();

export const forwarderSimulatorAdminContract = c.router({
  seedBatchSync: {
    method: 'POST',
    path: '/forwarder-simulator-admin/seed-batch-sync',
    body: z.object({
      batchId: z.string(),
      declarations: z.array(
        z.object({
          lrn: z.string(),
          sequence: z.number(),
          status: z.string(),
          customsState: z.any(),
        }),
      ),
    }),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },

  seedCustomsReport: {
    method: 'POST',
    path: '/forwarder-simulator-admin/seed-customs-report',
    body: z.object({
      batchId: z.string(),
      status: z.nativeEnum(ReportStatus),
    }),
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
});
